import Modal from './modal'

const modalContact = new Modal('.modal--contact', {
  openSelector: '.js-open-contact-modal'
})

let formSubmitted = false

function onFormSuccess(event) {
  const modal = document.querySelector('.modal--contact')
  if (!modal || !modal.contains(event.form)) return

  formSubmitted = true

  const heading = modal.querySelector('.modal-contact__heading')
  const description = modal.querySelector('.modal-contact__description')
  const body = modal.querySelector('.modal-contact__body')
  const footerCloseBtn = modal.querySelector('.modal__footer .js-close-modal')
  const footerNote = modal.querySelector('.modal__footer .note')

  if (heading) {
    heading.textContent = modal.dataset.successHeading
  }

  if (description) {
    description.innerHTML = modal.dataset.successDescriptionA + '<br class="modal-contact__br"> ' + modal.dataset.successDescriptionB
  }

  if (body) {
    body.style.display = 'none'
  }

  if (footerNote) {
    footerNote.classList.add('hidden')
  }

  if (footerCloseBtn) {
    footerCloseBtn.classList.remove('hidden')
  }
}

function resetModal(modal) {
  if (!formSubmitted) return

  const heading = modal.querySelector('.modal-contact__heading')
  const description = modal.querySelector('.modal-contact__description')
  const body = modal.querySelector('.modal-contact__body')
  const footerCloseBtn = modal.querySelector('.modal__footer .js-close-modal')
  const footerNote = modal.querySelector('.modal__footer .note')
  const form = modal.querySelector('form')

  if (heading) {
    heading.textContent = modal.dataset.initialHeading
  }

  if (description) {
    description.textContent = modal.dataset.initialDescription
  }

  if (body) {
    body.style.display = ''
  }

  if (footerNote) {
    footerNote.classList.remove('hidden')
  }

  if (footerCloseBtn) {
    footerCloseBtn.classList.add('hidden')
  }

  if (form) {
    form.reset()

    // Refresh CSRF token via Blitz
    fetch('/actions/blitz/csrf/input')
      .then(res => {
        if (!res.ok) throw new Error('Failed to fetch CSRF')
        return res.text()
      })
      .then(html => {
        const csrfInput = form.querySelector('craft-csrf-input')
        if (csrfInput) {
          csrfInput.innerHTML = html
        }
      })
      .catch(() => {
        window.location.reload()
      })

    // Hide Freeform success message
    const successMessage = form.querySelector('.freeform-form-success')
    if (successMessage) {
      successMessage.remove()
    }
  }

  formSubmitted = false
  applyFormTranslations(modal)
}

function applyFormTranslations(modal) {
  const raw = modal.dataset.formTranslations
  if (!raw) return
  let map
  try {
    map = JSON.parse(raw)
  } catch (e) {
    return
  }
  modal.querySelectorAll('select option, .freeform-button-submit').forEach(el => {
    const translation = map[el.textContent.trim()]
    if (translation !== undefined) {
      el.textContent = translation
    }
  })
}

function onFormAjaxError(event) {
  const modal = document.querySelector('.modal--contact')
  if (!modal || !modal.contains(event.form)) return

  const form = event.form

  fetch('/actions/blitz/csrf/input')
    .then(res => {
      if (!res.ok) throw new Error('Failed to fetch CSRF')
      return res.text()
    })
    .then(html => {
      const csrfInput = form.querySelector('craft-csrf-input')
      if (csrfInput) csrfInput.innerHTML = html
    })
    .catch(() => {})

  const message = modal.dataset.errorMessage
  if (!message) return

  const observer = new MutationObserver((mutations, obs) => {
    obs.disconnect()
    mutations.forEach(mutation => {
      mutation.addedNodes.forEach(node => {
        if (node.nodeType !== 1 || !node.classList.contains('freeform-form-errors')) return
        const p = node.querySelector('p')
        if (p) p.textContent = message
      })
    })
  })
  observer.observe(form, { childList: true })
}

function onModalTransitionEnd(event) {
  if (event.propertyName !== 'opacity') return

  const modal = event.target.closest('.modal--contact')
  if (!modal || modal.classList.contains('modal--active')) return

  resetModal(modal)
}

export default {
  init: () => {
    modalContact.init()
    document.addEventListener('freeform-ajax-success', onFormSuccess)
    document.addEventListener('freeform-ajax-error', onFormAjaxError)

    const modal = document.querySelector('.modal--contact')
    if (modal) {
      modal.addEventListener('transitionend', onModalTransitionEnd)
      applyFormTranslations(modal)
    }
  },
  destroy: () => {
    modalContact.destroy()
    document.removeEventListener('freeform-ajax-success', onFormSuccess)
    document.removeEventListener('freeform-ajax-error', onFormAjaxError)

    const modal = document.querySelector('.modal--contact')
    if (modal) {
      modal.removeEventListener('transitionend', onModalTransitionEnd)
    }
  }
}
